export const filtersToParams = (filters = []) => {
  let params = "";

  if (filters.length > 0) {
    filters.forEach(filter => {
      params += `&${filter.id}=${filter.value}`;
    });
  }

  return params;
};
